import { MessageSquare, ArrowRightLeft, Users, Paperclip, CircleCheck } from 'lucide-react';
import type { TFunction } from 'i18next';
import { TASK_ACTIVITY_CATEGORY, type TaskActivityCategory } from '../types';

export type BoardActivityFilterValue = Exclude<TaskActivityCategory, 'general'>;

export const BOARD_ACTIVITY_FILTERS: BoardActivityFilterValue[] = [
  TASK_ACTIVITY_CATEGORY.Comment,
  TASK_ACTIVITY_CATEGORY.StatusChange,
  TASK_ACTIVITY_CATEGORY.Assignment,
  TASK_ACTIVITY_CATEGORY.Attachment,
];

const FILTER_I18N_KEY: Record<BoardActivityFilterValue, string> = {
  [TASK_ACTIVITY_CATEGORY.Comment]: 'comment',
  [TASK_ACTIVITY_CATEGORY.StatusChange]: 'statusChange',
  [TASK_ACTIVITY_CATEGORY.Assignment]: 'assignment',
  [TASK_ACTIVITY_CATEGORY.Attachment]: 'attachment',
};

export function getBoardActivityFilterLabel(t: TFunction, value: BoardActivityFilterValue): string {
  return t(`activity.filters.${FILTER_I18N_KEY[value]}`);
}

/** Icon for the small badge overlapping the actor's avatar in the feed, keyed by `TaskActivityCategory` — index directly (with a `?? CATEGORY_ICON.general` fallback) rather than through a function, so the JSX tag resolves via a plain member expression. */
export const CATEGORY_ICON: Record<TaskActivityCategory, typeof MessageSquare> = {
  [TASK_ACTIVITY_CATEGORY.Comment]: MessageSquare,
  [TASK_ACTIVITY_CATEGORY.StatusChange]: CircleCheck,
  [TASK_ACTIVITY_CATEGORY.Assignment]: Users,
  [TASK_ACTIVITY_CATEGORY.Attachment]: Paperclip,
  [TASK_ACTIVITY_CATEGORY.General]: ArrowRightLeft,
};
